<style lang="scss" scoped>
@import '@@/assets/css/global.scss';
.container {
  margin-top: 20px;

  .records {
    box-sizing: border-box;

    .record {
      box-sizing: border-box;
      padding: 20px;
      padding-top: 10px;
      border: 1px solid #ededed;
      margin-bottom: 20px;
      border-radius: 4px;
      box-shadow: 0px 0px 4px #ededed;
      font-size: 16px;

      .header {
        border-bottom: 1px solid #ededed;
        padding-bottom: 10px;
        font-weight: bold;
      }

      .infos {
        padding-top: 10px;
        display: flex;
        justify-content: space-between;

        .left {
          flex: 1;
        }

        .right {
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-end;
        }
      }
    }
  }
}
</style>
<template>
  <div v-loading="loading">
    <div class="container">
      <div class="records">
        <div class="record" v-for="(record, index) in records" :key="record.id">
          <div class="header">{{ record.operatorName }}</div>
          <div class="infos">
            <div class="left">
              <div class="info">{{ $t('baogongshijian') }}:{{ record.gmtCreate | time('YYYY-MM-DD HH:mm:ss') }}</div>
              <div class="info">{{ $t('baogongbanci') }}:{{ record.shiftName }}</div>
              <div class="info">{{ $t('baogongshuliang') }}:{{ record.completedQty }}</div>
            </div>
            <div class="right">
              <div></div>
              <div class="state">{{ $t('baogongbuliangshu') }}:{{ record.unqualitifiedQty }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'gongdan_record',
  components: {},
  props: {
    wo: null
  },

  data() {
    return {
      wo: null,
      records: [],
      loading: false
    };
  },

  computed: {
    woid() {
      return this.wo ? this.wo.id : null;
    }
  },
  watch: {
    woid: {
      handler(n, o) {
        this.listRecords();
      },
      immediate: true,
      deep: true
    }
  },
  created() {},
  mounted() {},
  beforeDestroy() {},

  methods: {
    listRecords() {
      this.loading = true;
      let params = {
        page: 1,
        limit: 10000,
        woNo: this.wo.no
      };

      this.http
        .post('/production/app/worc/listByParams?' + this.qs.stringify(params))
        .then(res => {
          this.records = res.rows;
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
